import { BaseCropperController } from "./lib/image_cropper/base_cropper_controller"

/*
 * ImageCropperController
 *
 * Stimulus controller for managing benefit images (main image and logo).
 * Extends BaseCropperController with specific configuration for two
 * image types.
 *
 * Image types:
 *   - image: 5:4 main benefit image
 *   - logo:  Free ratio benefit logo
 */
export default class extends BaseCropperController {
  static targets = [
    "imageInput", "imagePreview", "imageCropButton", "imageModal", "imageModalImage",
    "imageCropData", "imageSourceUrl", "imageSourceInput", "imageCroppedInput",
    "imagePreviewData", "imageOriginalData",
    "logoInput", "logoPreview", "logoCropButton", "logoModal", "logoModalImage",
    "logoCropData", "logoSourceUrl", "logoSourceInput", "logoCroppedInput",
    "logoPreviewData", "logoOriginalData"
  ]

  /*
   * imageTypes
   *
   * List of image type identifiers handled by this controller.
   */
  static imageTypes = ["image", "logo"]

  /*
   * imageConfig
   *
   * Configuration for each image type. Uses JPEG format with white
   * background for better file size on benefit images.
   */
  static imageConfig = {
    image: {
      maxWidth: 2400,
      maxHeight: 1350,
      aspectRatio: 5 / 4,
      format: "jpeg",
      quality: 0.85,
      backgroundColor: "white"
    },
    logo: {
      maxWidth: 1000,
      maxHeight: 1000,
      aspectRatio: NaN,
      format: "png",
      backgroundColor: "transparent"
    }
  }

  /*
   * getTargetsForType
   *
   * Returns all target elements for a given image type.
   *
   * Input:
   *   type {string} - Image type identifier.
   *
   * Output:
   *   {object} - Object containing all target elements for this type.
   */
  getTargetsForType(type) {
    return {
      preview: this[`${type}PreviewTarget`],
      cropButton: this[`${type}CropButtonTarget`],
      modal: this[`${type}ModalTarget`],
      modalImage: this[`${type}ModalImageTarget`],
      cropData: this[`${type}CropDataTarget`],
      previewData: this[`${type}PreviewDataTarget`],
      originalData: this[`${type}OriginalDataTarget`],
      sourceInput: this[`${type}SourceInputTarget`],
      croppedInput: this[`${type}CroppedInputTarget`],
      sourceUrl: this[`${type}SourceUrlTarget`],
      originalUrl: null
    }
  }
}
